module.exports = __webpack_public_path__ + "static/media/11.35f65d0c.jpg";